import React from 'react';
import PropTypes from 'prop-types';
import { HashLink as Link } from 'react-router-hash-link';
import cx from 'classnames';

import './button.css';

const Button = ({ className, href, isYellow, text, to, ...props }) => {
    const Tag = to ? Link : href ? 'a' : 'div';
    return (
        <Tag
            className={cx('button', className, { button_yellow: isYellow })}
            href={href}
            to={to}
            {...props}
        >
            <span className="button__text">{text}</span>
        </Tag>
    );
};

Button.propTypes = {
    className: PropTypes.string,
    href: PropTypes.string,
    isYellow: PropTypes.bool,
    text: PropTypes.string.isRequired,
    to: PropTypes.string
};

export default Button;
